export const GET_PRODUCT_GROUPS_URL = '/api/v1/products/groups'
/** The dashboard aggregate: every service, grouped by type, in one call. */
export const GET_USER_SERVICES_URL = '/api/v1/user/services'
export const GET_UPCOMING_INVOICES_URL = '/api/v1/user/invoice/upcoming'
export const USER_NOTIFICATIONS_URL = '/api/v1/user/notifications'
